module.exports = __webpack_public_path__ + "img/积分兑换.9108f8c5.png";